import * as React from 'react';

const Loader = () => (
	<div className="m-card__loader">
		<div className="a-loader js-a-loader">
			<div className="a-loader__wrap">
				<span className="a-loader__dot" />
				<span className="a-loader__dot" />
				<span className="a-loader__dot" />
				<span className="a-loader__dot" />
				<span className="a-loader__dot" />
				<span className="a-loader__dot" />
			</div>
		</div>
	</div>
);

Loader.displayName = 'Card(Loader)';

export default Loader;
